var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"wecoupon-mall-title"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.$props.title))]),_c('div',{staticClass:"my-coupons",on:{"click":_vm.handleClick}},[_vm._v(_vm._s(_vm.i18n('已領優惠券')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }